// Traductions des noms de capteurs
const SENSOR_LABELS = {
  temperature: 'Température',
  humidity: 'Humidité',
  CO2: 'CO2',
  TVOC: 'TVOC',
  sound: 'Son',
  PM1_0: 'PM1.0',
  PM2_5: 'PM2.5',
  PM10: 'PM10',
  groundHumidity: 'Humidité du sol',
  ground_humidity: 'Humidité du sol'
};

export const getSensorLabel = (key) => {
  return SENSOR_LABELS[key] || key;
};

